/**
 * @fileoverview Serialize a ChartSpec into the `chartBlock` HTML element and
 * parse it back. The spec lives JSON-encoded in a single attribute so the
 * canvas `html` field round-trips unchanged. The attribute is single-quoted;
 * the JSON is escaped for `'` and `<`.
 */
import { ChartSpecSchema, type ChartSpec } from "@cvx/lib/charts/spec";

export function encodeChartAttr(spec: ChartSpec): string {
  return JSON.stringify(spec).replace(/'/g, "&#39;").replace(/</g, "&lt;");
}

export function chartSpecFromAttr(attr: string): ChartSpec | null {
  try {
    const json = attr.replace(/&#39;/g, "'").replace(/&lt;/g, "<");
    const parsed = ChartSpecSchema.safeParse(JSON.parse(json));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

/** Block element TipTap parses into a `chartBlock` node. */
export function specToChartHtml(spec: ChartSpec): string {
  return `<div data-morgan-chart='${encodeChartAttr(spec)}'></div>`;
}
